import script from "./ListRelayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListRelayer.vue?vue&type=script&setup=true&lang=ts"

import "./ListRelayer.vue?vue&type=style&index=0&id=514931c4&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-514931c4"]])

export default __exports__